import { MathUtil } from "@base/math/MathUtil";

export interface IMinMax {
  min: number;
  max: number;
}

export class MinMax {
  static clamp(value: number, minMax: IMinMax | number | number[]): number {
    if (typeof minMax === "number")
      return value;
    else if (Array.isArray(minMax)) {
      let nearestIndex = 0;
      let nearestValue = Number.MAX_VALUE;
      for (let i = 0; i < minMax.length; i++) {
        const m = minMax[i];
        if (m === value)
          return value;
        const dist = Math.abs(m - value);
        if (dist < nearestValue) {
          nearestValue = dist;
          nearestIndex = i;
        }
      }
      return minMax[nearestIndex];
    }

    if (minMax.min > minMax.max)
      return MinMax.mid(minMax);

    return MathUtil.clamp(value, minMax.min, minMax.max);
  }

  static mid(minMax: IMinMax): number {
    return (minMax.min + minMax.max) * 0.5;
  }

  static transform<T extends (number | number[] | IMinMax)>(v: T, fn: (m: number) => number): T {
    if (typeof v === "number") {
      return fn(v) as T;
    } else if (Array.isArray(v)) {
      return v.map((m) => fn(m)) as T
    }
    return {
      min: fn(v.min),
      max: fn(v.max),
    } as T
  }
}